export default {"src":"/_next/static/media/lock.74ff032b.svg","height":402,"width":402,"blurWidth":0,"blurHeight":0};